import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { listConnections, SchemaQueryKeys, type ModelProviderResponse } from '../api';

/**
 * Lists every configured model provider for the tenant.
 * Wave 4 (`agent-ui-config`) owns the write surface; we only consume the read shape here.
 */
export function useConnections(): UseQueryResult<ModelProviderResponse[]> {
  return useQuery({
    queryKey: SchemaQueryKeys.connections,
    queryFn: ({ signal }) => listConnections(signal),
  });
}
